import { render, staticRenderFns } from "./mateMore.vue?vue&type=template&id=50f00059&scoped=true&"
import script from "./mateMore.vue?vue&type=script&lang=js&"
export * from "./mateMore.vue?vue&type=script&lang=js&"
import style0 from "./mateMore.vue?vue&type=style&index=0&id=50f00059&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f00059",
  null
  
)

export default component.exports